<div class="select-with-other" [class.has-custom]="IsCustomValue">

    <ion-select *ngIf="Data?.length>0" [interface]="'popover'" class="outline" [disabled]="IsDisabled"
        [value]="SelectValue" (ionChange)="OnChangeSelect($event)">
        <ion-select-option disabled value="">{{SelectPlaceholder}}</ion-select-option>
        <ion-select-option *ngFor="let item of Data" [value]="item?.Label">{{item?.Label}}</ion-select-option>
        <ion-select-option [value]="OtherValue">{{OtherLabel}}</ion-select-option>
    </ion-select>

    <ion-input *ngIf="Data?.length>0 && IsCustomValue" [disabled]="IsDisabled" [value]="Value"
        (ionInput)="OnChangeInput($event)" [placeholder]="Placeholder" autocomplete="off"></ion-input>

    <ion-input *ngIf="!Data || Data?.length==0" [disabled]="IsDisabled" [value]="Value"
        (ionInput)="OnChangeInput($event)" [placeholder]="Placeholder" autocomplete="off"></ion-input>

</div>
